document.querySelectorAll('[data-predictive-search]').forEach((root) => {
  const input = root.querySelector('input[type="search"]');
  const results = root.querySelector('[data-results]');
  if (!input || !results) return;
  let timer;
  let controller;
  let revision = 0;
  const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
  const clear = () => {
    revision++;
    window.clearTimeout(timer);
    controller?.abort();
    results.replaceChildren();
    results.removeAttribute('aria-busy');
    close();
  };
  input.addEventListener('input', () => {
    clear();
    const query = input.value.trim();
    if (query.length < 2) return;
    const current = revision;
    timer = window.setTimeout(async () => {
      controller = new AbortController();
      results.setAttribute('aria-busy', 'true');
      const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (current !== revision) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.predictive-search');
        if (!content) return;
        results.replaceChildren(content.cloneNode(true));
        results.hidden = !root.contains(document.activeElement);
        input.setAttribute('aria-expanded', String(!results.hidden));
      } catch (error) {
        if (current === revision && error.name !== 'AbortError') close();
      } finally {
        if (current === revision) results.removeAttribute('aria-busy');
      }
    }, 220);
  });
  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { clear(); input.focus(); return; }
    if (results.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    const links = [...results.querySelectorAll('a[href]')];
    if (!links.length) return;
    event.preventDefault();
    const index = links.indexOf(document.activeElement);
    const next = event.key === 'ArrowDown' ? index + 1 : index < 0 ? links.length - 1 : index - 1;
    if (next < 0) input.focus();
    else links[Math.min(next, links.length - 1)].focus();
  });
  root.addEventListener('focusout', () => window.setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0));
  input.addEventListener('focus', () => { if (results.childElementCount) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
  root.addEventListener('reset', clear);
  root.addEventListener('submit', clear);
});
